<!-- Mobile view -->
<div class="flex flex-col gap-4 lg:hidden">
  <ng-container *ngTemplateOutlet="logo"></ng-container>
  <div class="flex items-center">
    <ng-container *ngTemplateOutlet="helpLink"></ng-container>
    <div class="grow max-w-[81px] flex justify-center">
      <div class="border-l border-foreground-primary-20 h-6 shrink-0"></div>
    </div>
    <ng-container *ngTemplateOutlet="documents"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="version"></ng-container>
  <ng-container *ngTemplateOutlet="copyright"></ng-container>
</div>

<!-- Desktop view -->
<div class="hidden lg:flex justify-between gap-4">
  <div class="flex items-center gap-10">
    <ng-container *ngTemplateOutlet="logo"></ng-container>

    <div class="border-l border-foreground-primary-20 h-6"></div>

    <ng-container *ngTemplateOutlet="copyright"></ng-container>
  </div>

  <div class="flex items-center gap-10">
    <ng-container *ngTemplateOutlet="version"></ng-container>

    <div class="border-l border-foreground-primary-20 h-6"></div>

    <ng-container *ngTemplateOutlet="helpLink"></ng-container>

    <div class="border-l border-foreground-primary-20 h-6"></div>

    <ng-container *ngTemplateOutlet="documents"></ng-container>
  </div>
</div>

<ng-template #logo>
  <div class="flex items-center gap-[6px]">
    <span>{{ 'footer.powered-by' | translate }}</span>
    <img
      src="/images/footer-logo.svg"
      [attr.alt]="'footer.logo-alt' | translate"
      width="77px"
      height="24px"
      class="pointer-events-none shrink-0"
    />
  </div>
</ng-template>
<ng-template #version>
  <span class="text-foreground-primary-40">{{ 'footer.version' | translate }} {{ APP_VERSION }}</span>
</ng-template>
<ng-template #helpLink>
  <a href="mailto:support@optimoenergy.io" class="shrink-0 font-semibold">{{ 'footer.help' | translate }}</a>
</ng-template>
<ng-template #documents>
  <div class="shrink-0 flex items-center gap-6">
    <a href="https://www.optimoenergy.io/privacy-policy" target="_blank" class="font-medium">{{ 'footer.privacy-policy' | translate }}</a>
    <a href="https://www.optimoenergy.io/cookie-policy" target="_blank" class="font-medium">{{ 'footer.cookie-policy' | translate }}</a>
  </div>
</ng-template>
<ng-template #copyright>
  <span>{{ 'footer.copyright' | translate }}</span>
</ng-template>
